import axios from "axios";

export default {
    get(id) {
        return axios({
            method: "get",
            url: process.env.VUE_APP_BASE_URL_CORE + "auth/account/" + id,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    getHistoryBetweenDates(id, data) {
        return axios({
            method: "post",
            data: data,
            url:
                process.env.VUE_APP_BASE_URL_CORE + "auth/account/" + id + "/history",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    recharge(id, data) {
        return axios({
            method: "post",
            data: data,
            url:
                process.env.VUE_APP_BASE_URL_CORE + "auth/account/" + id + "/recharge",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
};
